import { motion, useReducedMotion } from "framer-motion";

// Subtle scroll-in fade/slide, once per element (~300ms). Respects reduced-motion.
export const Reveal = ({ children, delay = 0, y = 16, className = "", as = "div" }) => {
  const reduce = useReducedMotion();
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={reduce ? { opacity: 0 } : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.3, delay: reduce ? 0 : delay, ease: "easeOut" }}
    >
      {children}
    </MotionTag>
  );
};
